module.exports = "<select class=\"form-control\"\n        ng-if=\"$ctrl.mode === 'edit'\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-disabled=\"$ctrl.ngDisabled\"\n        ng-change=\"$ctrl._ngChange()\"\n        ng-options=\"item.id as item.name for item in $ctrl.store.list\">\n    <option value=\"\">Show all</option>\n</select>\n<span ng-if=\"$ctrl.mode === 'view'\" class=\"label label-default\" style=\"background-color: #999\" ng-bind=\"$ctrl.ngModel.name\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/role.picker.html
// module id = 778
// module chunks = 0